import { Component } from '@angular/core';

@Component({
    selector: 'app-submission-success-dialog',
    templateUrl: './submission-success-dialog.component.html',
    styleUrls: ['./submission-success-dialog.component.scss'],
    standalone: false
})
export class SubmissionSuccessDialogComponent {

}
